import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import * as Utilities from '../ts/Utilities';
import * as DateTimeFunctions from '../../../_common/platform/ts/DateTimeFunctions';

import NumberField from './NumberField';
import StringField from './StringField';

import * as appTheme from '../ts/appTheme';

import {
    DiscreteIntervalsKind,
    getKindList_forDiscreteMapping,
    DiscreteIntervals_forKind,
    dataTypes,
    DateTime_RenderComponent,
    Time_RenderComponent,
    Color_RenderComponent,
    IKindListForDiscreteMapping
} from './DiscreteIntervals';

import RadioGroupFieldComponent from './RadioGroupField';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');
const Globalize = require('pdc-platform-Globalize');

//LL: from ColorMappingForNumericField:
const startColorDefault = '#ffff00'; // yellow   or "#ffff80"
const endColorDefault = '#b70000'; // cranberry
//var nullColorDefault = null;
const mappingTypes = ['linear', 'logarithmic', 'discrete'];
const mappingIndexDefault = 2; //0;

//LL: 'number', instead of i, r
//var dataTypes = [ 'number', 'date', 'datetime', 'time', 'string'];   //LL:  defined in DiscreteIntervals.tsx

const dataTypesIndexDefault = 0;

//LL: see DiscreteIntervals KindList   icon, label are not continuous
//    and CMFN for start/end values

// time: as in DiscreteIntervals.tsx
const TimeValueFormat = DateTimeFunctions.TimeValueFormat; // 'yyyy-MM-ddTHH:mm:ss'
//const TimeDisplayFormat = DateTimeFunctions.TimeDisplayFormat; // 'HH:mm:ss'
//const TimeDisplayFormatShort = DateTimeFunctions.TimeDisplayFormatShort;  // 'HH:mm'
//const timeInfinityMinus = '00:00:00';
//const timeInfinity = '24:00:00';

// date:  as in DiscreteIntervals.tsx
const DateValueFormat = 'yyyy-MM-dd';
// const DateTimeValueFormat = 'yyyy-MM-dd HH:mm:ss';
// const DateTimeValueFormatT = 'yyyy-MM-ddTHH:mm:ss';

// time:  as in DiscreteIntervals.tsx
function getMinTimeDate() {
    // NOT  new Date(0);  // 03:00:00 with TZ
    return new Date(0, 0, 0, 0, 0, 0);
}
function getMaxTimeDate() {
    return new Date(0, 0, 0, 23, 59, 59, 999);
}

//LL:  new:   for linear and logarithmic
class ContinuousScalePopup extends React.Component<
    {
        zIndex: number;
        options: any;
        close();
        glob: IGlob;
    },
    {
        value;
        hasIntervalError;
        height?: number;
        width?: number;
    }
> {
    private references: {
        popoverContent?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        const valueOrig = $.extend(true, {}, this.props.options.value);
        //   scaleMethod, scaleMin, scaleMax

        this.state = {
            value: valueOrig, //this.props.options.value
            hasIntervalError: false,
            height: 500, //LL: as in FormatChooser  ??? can change, depends on current Tab  Reset in DidMount
            width: 530 //LL: as in FormatChooser   sass - 520      Reset in DidMount
        };
    }

    private globalClickIndex = 0;

    componentDidMount() {
        if (this.props.options.popupPriority != null) {
            this.globalClickIndex = reactGlobalClick.register(this.props.close, this.props.options.popupPriority);
        } else {
            this.globalClickIndex = reactGlobalClick.register(this.props.close);
        }

        const dialog: any = this.references.popoverContent;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    componentWillUnmount() {
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    handleChange = (value, hasIntervalError?) => {
        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });

        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(value);
        // }
    };

    containerClick = (e) => {
        if (this.props.options.popupPriority != null) {
            reactGlobalClick.trigger(e, this.props.options.popupPriority + 1);
            reactGlobalClick.cancel();
        }

        //LL:  commented.
        //   It was forbidding proper closing of previous popup when "click-on-cog" (reactGlobalClick.trigger was not called)
        //e.stopPropagation();
        //e.preventDefault();
    };

    closeButtonHandler = () => {
        let hasError = this.state.hasIntervalError;
        if (hasError != true) {
            let errors = []; //validateWhole(this.state.value, this.props.options.type);
            if (errors.length > 0) {
                hasError = true;
            }
        }

        if (hasError === true) {
            //no  this.props.options.glob.AppActions.showNotification_Warning('Configuration is not valid. Some fields have wrong value');
        } else {
            if (typeof this.props.options.onChange === 'function') {
                this.props.options.onChange(this.state.value);
            }
            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        this.props.close();
    };

    processScaleMethodChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.scaleMethod = val;
        this.setState({ value: obj });
    };

    processScaleMinChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.scaleMin = val;
        //this.handleValueChange(obj);
        this.setState({ value: obj });
    };

    processScaleMaxChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.scaleMax = val;
        //this.handleValueChange(obj);
        this.setState({ value: obj });
    };

    processTargetStartChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.startValue = val;
        this.setState({ value: obj });
    };

    processTargetEndChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.endValue = val;
        this.setState({ value: obj });
    };

    getScaleMethod_Automatic_Content = (disabled) => {
        //LL: now "disabled" is not used here
        let content = <div className="scale-method">{'Scale by actual values'}</div>;

        return content;
    };

    getScaleMethod_DefineRange_Content = (disabled) => {
        const minText: any = 'Min: ';
        const maxText: any = 'Max: ';

        //LL: here Numeric, must be other types   Number, Date, DateTime, Time
        //type: this.props.options.type,  -- for Source Type:  Source Types can be all except "string" (continuous)
        //   see class DiscreteIntervals  in DiscreteIntervals.tsx  =>  class Interval  getInput()
        //   maybe use  kind ?

        let dataType = this.props.options.type; //  == sourceType

        const displayValMin: any = this.state.value.scaleMin || this.getInitialValue_forSourceContinuousRange(dataType);
        const displayValMax: any = this.state.value.scaleMax || this.getInitialValue_forSourceContinuousRange(dataType);

        let minField, maxField;

        let kind: DiscreteIntervalsKind = this.convertDataTypeToDataKind(dataType);
        minField = this.getDefineRangeElement_byKind(kind, displayValMin, this.processScaleMinChange, disabled);
        maxField = this.getDefineRangeElement_byKind(kind, displayValMax, this.processScaleMaxChange, disabled);

        let content = (
            <div className="scale-method">
                <div className="scale-method-block">
                    <label className="scale-method-text">{minText}</label>
                    <div className="scale-method-input">{minField}</div>
                </div>
                <div className="scale-method-block">
                    <label className="scale-method-text">{maxText}</label>
                    <div className="scale-method-input">{maxField}</div>
                </div>
            </div>
        );

        return content;
    };

    getInitialValue_forSourceContinuousRange = (dataType) => {
        switch (dataType) {
            case 'i':
            case 'r':
            case 'number':
                return 0;

            case 'date':
            case 'datetime':
                return Globalize('en').formatDate(new Date(), {
                    raw: DateValueFormat
                }); // 'yyyy-MM-dd'

            case 'time':
                let D = getMinTimeDate();

                //return Globalize.formatDate(D, { raw: TimeValueFormat });
                return Globalize('en').formatDate(D, { raw: TimeValueFormat }); //LL: 17.12.19: was error for Danish

            default:
                return '';
        }
    };

    getInitialValue_forTargetContinuousRange = (kind: DiscreteIntervalsKind, isStart: boolean) => {
        //LL:  without label and icon
        switch (kind) {
            case DiscreteIntervalsKind.integer:
            case DiscreteIntervalsKind.real:
            case DiscreteIntervalsKind.number:
                return 0;

            case DiscreteIntervalsKind.date:
            case DiscreteIntervalsKind.datetime:
                return Globalize('en').formatDate(new Date(), {
                    raw: DateValueFormat
                }); // 'yyyy-MM-dd'

            case DiscreteIntervalsKind.time:
                //let D = getMinTimeDate();
                let D = isStart ? getMinTimeDate() : getMaxTimeDate();

                //return Globalize.formatDate(D, { raw: TimeValueFormat });
                return Globalize('en').formatDate(D, { raw: TimeValueFormat }); //LL: 17.12.19: was error for Danish

            case DiscreteIntervalsKind.color:
                return isStart ? startColorDefault : endColorDefault;

            default:
                return '';
        }
    };

    convertDataTypeToDataKind = (dataType) => {
        //LL:  'string' is prohibited for "continuous" mapping
        switch (dataType) {
            case 'i':
                return DiscreteIntervalsKind.integer;
            case 'r':
                return DiscreteIntervalsKind.real;
            case 'number':
                return DiscreteIntervalsKind.number;

            case 'date':
                return DiscreteIntervalsKind.date;
            case 'datetime':
                return DiscreteIntervalsKind.datetime;
            case 'time':
                return DiscreteIntervalsKind.time;

            default:
                return DiscreteIntervalsKind.label;
        }
    };

    getDefineRangeElement_byKind = (kind: DiscreteIntervalsKind, value, onChangeFunc, disabled = false) => {
        let elem = null;
        //LL:  allowNull={ false }, so value is not null.   But maybe check ?
        //LL: if disabled: show text value
        let textValue;

        //LL:  'string'('label') and 'icon' are prohibited for "continuous" mapping
        switch (kind) {
            case DiscreteIntervalsKind.integer:
            case DiscreteIntervalsKind.real:
            case DiscreteIntervalsKind.number:
                if (disabled) {
                    textValue = value != null ? value.toString() : '';
                } else {
                    elem = (
                        <NumberField
                            value={value}
                            allowNull={false}
                            applyOnEnter={true}
                            integer={false}
                            onChange={onChangeFunc}
                        />
                    );
                }
                break;

            case DiscreteIntervalsKind.date:
            case DiscreteIntervalsKind.datetime:
                if (disabled) {
                    textValue = value != null ? value.toString() : '';
                    //if (value == null) {
                    //    textValue = "";
                    //}
                    //else {
                    //    let isDateTime = (kind === DiscreteIntervalsKind.datetime);
                    //    let displayDateFormat = (isDateTime ? DateTimeValueFormat : DateValueFormat);
                    //    textValue = Globalize("en").formatDate(value, { raw: DateTimeValueFormat });
                    //    //  Invalid `value` parameter (2020-01-13T06:03:00). Date expected.
                    //    //LL: our DateField returns:  isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
                    //    //LL:  so first Parse, and then Format
                    //}
                } else {
                    //LL:  see DiscreteIntervals  DateTime_RenderComponent, interface IDiscreteIntervalsKindRenderComponent
                    let options: any = {
                        isDateTime: kind === DiscreteIntervalsKind.datetime
                    };
                    elem = (
                        <DateTime_RenderComponent
                            value={value}
                            options={options}
                            allowNull={false}
                            onChange={onChangeFunc}
                        />
                    );
                }
                break;

            case DiscreteIntervalsKind.time:
                if (disabled) {
                    textValue = value != null ? value.toString() : '';
                } else {
                    //LL: 27.01.20: but "rollers" show only Hour and Minute, no Seconds, so Seconds cannot be changed.  In input part ?
                    let optionsT: any = { showSeconds: true };
                    elem = (
                        <Time_RenderComponent
                            value={value}
                            options={optionsT}
                            allowNull={false}
                            onChange={onChangeFunc}
                        />
                    );
                }
                break;

            case DiscreteIntervalsKind.color:
                if (disabled) {
                    textValue = value != null ? value.toString() : '';
                } else {
                    //   allowNull={ false }
                    elem = (
                        <Color_RenderComponent
                            value={value}
                            themeObj={this.props.options.themeObj}
                            glob={this.props.options.glob}
                            onChange={onChangeFunc}
                        />
                    );
                }
                break;
        }

        if (disabled) {
            elem = <input className="form-control" type="text" disabled={true} value={textValue} />;
        }

        return elem;
    };

    getSourceInterval = () => {
        //type: this.props.options.type,  -- for Source Type:  Source Types can be all except "string" (continuous)

        //  See CMFN

        //obj.startColor = startColorDefault;
        //obj.endColor = endColorDefault;
        //obj.nullColor = nullColorDefault; //LL: 26.11.19: for not-discrete, Null values
        //
        //obj.scaleAuto = true;    NO
        //obj.scaleMin = 0;
        //obj.scaleMax = 0;
        //  scaleMethod

        let rgItems: any = [];

        let curScaleMethod = this.state.value.scaleMethod;
        if (curScaleMethod == null) {
            curScaleMethod = 'automatic';
        }

        let disabledAutomaticContent = curScaleMethod !== 'automatic';
        let disabledDefineRangeContent = curScaleMethod !== 'defineRange';

        rgItems.push({
            text: 'Automatic',
            value: 'automatic',
            content: this.getScaleMethod_Automatic_Content(disabledAutomaticContent)
        });

        rgItems.push({
            text: 'Define Range',
            value: 'defineRange',
            content: this.getScaleMethod_DefineRange_Content(disabledDefineRangeContent)
        });

        let rgOptions = {
            name: 'RG_scaleMethod', //LL: needed to differ RadioGroup from other RadioGroups
            layout: 'vertical',
            items: rgItems
        };

        let styleScaleMethod: React.CSSProperties = { marginTop: '5px', marginBottom: '5px' }; // ??
        let elemRG = (
            <div style={styleScaleMethod}>
                <RadioGroupFieldComponent
                    value={curScaleMethod}
                    options={rgOptions}
                    onChange={this.processScaleMethodChange}
                />
            </div>
        );

        let elem = <div className="source-block">{elemRG}</div>;

        return elem;
    };

    getTargetInterval = () => {
        //kind: this.props.options.kind,  -- for Target Type"  Target Types can be all except "string" and "image"(icon) (continuous)
        let kind = this.props.options.kind; //  = targetType

        //LL: here Number, must be other types   Color, Number, Date, DateTime, Time
        //  Target: (startColor, endColor, nullColor)  startValue, endValue, nullValue

        let valueText = kind === DiscreteIntervalsKind.color ? 'Color' : 'Value';

        const startText = 'Start ' + valueText + ':';
        const endText = 'End ' + valueText + ':';

        const displayValStart =
            this.state.value.startValue || this.getInitialValue_forTargetContinuousRange(kind, true);
        const displayValEnd = this.state.value.endValue || this.getInitialValue_forTargetContinuousRange(kind, false);

        let startField = this.getDefineRangeElement_byKind(kind, displayValStart, this.processTargetStartChange);
        let endField = this.getDefineRangeElement_byKind(kind, displayValEnd, this.processTargetEndChange);

        //LL:  see CMFN getColorSample
        let sample;
        if (this.props.options.kind === DiscreteIntervalsKind.color) {
            let startColor = displayValStart;
            let endColor = displayValEnd;

            let style1 = {
                paddingTop: 0,
                paddingBottom: 0
            };

            let style2 = {
                marginTop: 4,
                height: 15,
                background: 'linear-gradient(to right, ' + startColor + ', ' + endColor + ')'
            };

            sample = (
                <div className="form-control" style={style1}>
                    <div className="form-control" style={style2} />
                </div>
            );
        }

        let content = (
            <div className="target-value">
                <div className="target-value-block">
                    <label className="target-value-text">{startText}</label>
                    <div className="target-value-input">{startField}</div>
                </div>
                <div className="target-value-block">
                    <label className="target-value-text">{endText}</label>
                    <div className="target-value-input">{endField}</div>
                </div>
                {sample}
            </div>
        );

        let elem = <div className="target-block">{content}</div>;

        return elem;
    };

    getContinuousMapping = () => {
        //let discreteIntervalsElem =
        //    <DiscreteIntervals
        //        value={ this.state.value }
        //        type={ this.props.options.type }
        //        kind={ this.props.options.kind }
        //
        //        onChange={ this.handleChange }
        //
        //        themeObj={ this.props.options.themeObj }
        //
        //        popupPriority={ this.props.options.popupPriority }
        //
        //        glob={ this.props.glob }
        //    />;
        //=================================

        //value: this.props.options.value, -- value, see CMFN:  Source: scaleAuto, scaleMin, scaleMax; Target: startColor, endColor, nullColor
        //type: this.props.options.type,  -- for Source Type:  Source Types can be all except "string"   (continuous)
        //kind: this.props.options.kind,  -- for Target Type"  Target Types can be all except "string" and "image"(icon)  (continuous)
        //let kind = this.props.options.kind;

        let sourceIntervalElem = (
            <div className="continuous-mapping-block">
                <strong>{'Source Interval:'}</strong>
                {this.getSourceInterval()}
            </div>
        );

        let targetIntervalElem = (
            <div className="continuous-mapping-block">
                <strong>{'Target Interval:'}</strong>
                {this.getTargetInterval()}
            </div>
        );

        let nullMappingElem = (
            <div className="continuous-mapping-block">
                <strong>{'Null mapping:'}</strong>
            </div>
        );

        //LL: or without parent div ?  See https://reactjs.org/docs/fragments.html
        let continuousMappingElem = (
            <div className="continuous-mapping">
                {sourceIntervalElem}
                {targetIntervalElem}
                {nullMappingElem}
            </div>
        );

        return continuousMappingElem;
    };

    render() {
        const popoverStyle = Utilities.getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });

        let style: any = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: this.props.zIndex //LL: 11.11.19
        };

        let popupTitle = 'Continuous Scale'; // "Linear/Logarithmic Scale";

        //LL: Leo wants without header:
        let styleContinuousMapping: any = {};

        let continuousMappingContent = this.getContinuousMapping();

        let upperContent = (
            <div className="popover-body">
                <div style={styleContinuousMapping}>{continuousMappingContent}</div>
            </div>
        );

        let errorsElem = null;
        let hasError = this.state.hasIntervalError;
        //if (errors.length > 0) {
        //    hasError = true;
        //}
        let okButtonClass = 'btn btn-success';
        if (hasError === true) {
            okButtonClass += ' disabled';
        }

        return (
            <div className="linear-scale-popup">
                <div
                    className={'popover linear-scale-popover ' + popoverStyle.side}
                    style={style}
                    onClick={this.containerClick}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>

                    {errorsElem}

                    {upperContent}

                    <div className="modal-footer">
                        <button className={okButtonClass} onClick={this.closeButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

//LL:  new:   for linear and logarithmic
class ContinuousScale extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    //LL: see DiscreteIntervals_forKind
    //private globalClickIndex = 0; //LL: not here, needed in popups
    private popupPriority = 2; //LL: use in reactGlobalClick to close previous popup dialog,  ColorBoxField with additional popup will be inside

    componentDidMount() {}
    componentWillUnmount() {}

    handleChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value); //LL: to caller
        }
    };

    handleSelectorShow = (e) => {
        const offset = $(e.target).offset();

        let popupPriority = this.popupPriority;
        if (this.props.kind !== DiscreteIntervalsKind.color) {
            popupPriority = null;
        }

        this.props.glob.DialogActions.createPopup('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value,
            type: this.props.type,
            kind: this.props.kind,

            themeObj: this.props.themeObj,
            popupPriority: popupPriority,

            glob: this.props.glob,

            onChange: this.handleChange,

            component: ContinuousScalePopup
        });
    };

    render() {
        let labels; //LL: labels are "colors", "icons", "dates", etc
        //let title = "";

        let labelNull; //LL: nullMappedValue

        if (this.props.value == null || (this.props.value.values == null && this.props.value.nullMappedValue == null)) {
            labels = <em className="empty" onClick={this.handleSelectorShow}></em>;
        } else {
            //LL:  { kind: DiscreteIntervalsKind.label, columnHeader: "Label", emptyMappedValue: "", renderComponent: LabelRenderComponent, renderComponentResult }
            //let kindDescrObj = getKindDescrObject(this.props.kind);
            //let renderComponentResult: IDiscreteIntervalsKindRenderComponent = kindDescrObj.renderComponentResult;
        }

        //return (
        //    <div className="linear-scale">
        //        <span
        //            className="icon-container glyphicon glyphicon-cog"
        //            onClick={ this.handleSelectorShow }
        //        >
        //        </span>
        //    </div>
        //);

        return (
            <div className="linear-scale">
                <div className="content">
                    <span className="icon-container glyphicon glyphicon-cog" onClick={this.handleSelectorShow}></span>
                    <span className="form-control values-container">
                        {labelNull}
                        {labels}
                    </span>
                </div>
            </div>
        );
    }
}

class MappingFieldRow extends React.Component<
    {
        resultingTypes: IKindListForDiscreteMapping[];
        value?;
        i?: number;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;
        onChange?(value, index: number): void;
        onRemove?(index: number): void;
    },
    {}
> {
    private references: {
        mappingType?: HTMLElement;
        dataType?: HTMLElement;
        resultingType?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);
    }

    normalize(value) {
        if (value.name == null) {
            delete value.discreteIntervals;
            delete value.dataType;
            delete value.resultingType;
            delete value.mappingType; // new
            delete value.linearScale; // new

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}

        let find;

        //LL: from ColorMappingForNumericField:
        //LL: or create and use ConfigurationConstants.xxx.mappingTypes
        find = _.find(mappingTypes, function (val) {
            return val === value.mappingType;
        });

        if (find == null) {
            delete value.mappingType;
        }

        //LL: add 'number', instead of i, r
        if (value.dataType === 'i' || value.dataType === 'r') {
            value.dataType == 'number';
        }
    }

    getKindDescrObject = (_kind: DiscreteIntervalsKind) => {
        const kindList = this.props.resultingTypes;

        let result = kindList[0]; //  as default,  or null ?

        _.each(kindList, (obj) => {
            if (obj.kind === _kind) {
                result = obj;
                return;
            }
        });
        return result;
    };

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    //LL: from ColorMappingForNumericField:
    processMappingChange = (e) => {
        let elem: any = this.references.mappingType;
        let val = elem.value;
        let obj = _.clone(this.props.value || {});

        //LL:  1) must clear discreteIntervals or linearScale
        //LL:  2) check Target type, if change to linear

        obj.mappingType = val;
        this.handleValueChange(obj);
    };

    processDataTypeChange = (e) => {
        let elem: any = this.references.dataType;
        let val = elem.value;
        let obj = _.clone(this.props.value || {});

        //   linearScale

        //LL: must clear Intervals when DataType is changed
        let defined =
            obj.discreteIntervals != null &&
            obj.discreteIntervals.values != null &&
            obj.discreteIntervals.values.length > 0;

        if (defined) {
            let result = confirm('When Data Type is changed, Intervals will be cleared.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        //  clear:  nullMapped remains
        //  or obj.discreteIntervals = null;
        if (defined) {
            delete obj.discreteIntervals.values;
            delete obj.discreteIntervals.labels;
        }

        obj.dataType = val;
        this.handleValueChange(obj);
    };

    processResultingTypeChange = (e) => {
        let elem: any = this.references.resultingType;
        let val = elem.value; // it is string, not integer
        let num = Number(val);

        if (!isNaN(num)) {
            val = num;
        }

        let obj = _.clone(this.props.value || {});

        //  linearScale

        let defined =
            obj.discreteIntervals != null &&
            ((obj.discreteIntervals.labels != null && obj.discreteIntervals.labels.length > 0) ||
                obj.discreteIntervals.nullMappedValue != null);
        if (defined) {
            let result = confirm('When Resulting Type is changed, Mapped values will be cleared.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        //LL: clear discreteIntervals "labels":   and nullMappedValue
        let emptyMappedValue = '';
        let kindDescrObj = this.getKindDescrObject(val); // _kind: DiscreteIntervalsKind);

        if (kindDescrObj != null) {
            emptyMappedValue = kindDescrObj.emptyMappedValue;
        }

        if (
            obj.discreteIntervals != null &&
            obj.discreteIntervals.labels != null &&
            obj.discreteIntervals.labels.length > 0
        ) {
            let labels = _.map(obj.discreteIntervals.labels, function (a: any) {
                return emptyMappedValue;
            });
            obj.discreteIntervals.labels = labels;
        }
        if (obj.discreteIntervals != null && obj.discreteIntervals.nullMappedValue != null) {
            obj.discreteIntervals.nullMappedValue = emptyMappedValue;
        }

        obj.resultingType = val;
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        //LL: changed => not inherited
        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        //LL: "disabled" not used
        if (value.disabled === true) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getNameTitle(value) {
        return value.name || '';
    }

    getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    canContinuousDataType(dataType) {
        //LL:  or SourceType
        return dataType !== 'string'; //  dataTypes = [ 'number', 'date', 'datetime', 'time', 'string'];
    }

    isDiscreteMappingType(mappingType) {
        return mappingType === 'discrete';
    }

    isDiscreteMapping(value) {
        return value.mappingType === 'discrete';
    }

    //LL: from ColorMappingForNumericField: was getMapping there
    getMappingType(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.mappingType || mappingTypes[mappingIndexDefault];
        let readOnly = value.disabled === true;
        let style1: any = {};

        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        //LL:  check Target type, if change from discrete to continuous (linear):
        let kindDescrObj = this.getKindDescrObject(value.resultingType);
        let target_canContinuous = kindDescrObj.canContinuous; //LL: except label and icon
        //LL:  and check Data (Source) type:
        let source_canContinuous = this.canContinuousDataType(value.dataType); //LL: except "string"

        let options = _.map(mappingTypes, (val) => {
            let disabled = target_canContinuous && source_canContinuous ? false : !this.isDiscreteMappingType(val);
            let title = disabled ? 'Current Target or Source Type cannot participate in continuous Mapping' : '';

            return (
                <option key={val} value={val} disabled={disabled} title={title}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.mappingType = input;
                }}
                className="form-control"
                style={style1}
                onChange={this.processMappingChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    getDataType(value) {
        //  == "Source Type"
        if (value.name == null) {
            return;
        }

        let displayVal = value.dataType || dataTypes[dataTypesIndexDefault];
        let readOnly = value.disabled === true;
        let style1: any = {};

        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        //LL:  check Mapping type, "discrete": all Source Types, "continuous": only when canContinuous
        let isDiscreteMapping = this.isDiscreteMappingType(value.mappingType);
        let options = _.map(dataTypes, (val) => {
            let disabled = false;

            if (!isDiscreteMapping) {
                let canContinuous = this.canContinuousDataType(val);
                disabled = !canContinuous;
            }

            let title = disabled ? 'Current Mapping Type cannot be applied to this Source Type' : '';

            return (
                <option key={val} value={val} disabled={disabled} title={title}>
                    {Utilities.explainAttributeType(val)}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.dataType = input;
                }}
                className="form-control"
                style={style1}
                onChange={this.processDataTypeChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    getResultingType = (value) => {
        if (value.name == null) {
            return;
        }

        //LL: it is "kind" of DiscreteIntervals

        let displayVal = value.resultingType || this.props.resultingTypes[0].kind;
        let readOnly = value.disabled === true;
        let style1: any = {};

        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        //LL:  check Mapping type, "discrete": all Targets, "continuous": only when canContinuous
        let isDiscreteMapping = this.isDiscreteMappingType(value.mappingType);

        let options = _.map(this.props.resultingTypes, (resultingType) => {
            let disabled = false;

            if (!isDiscreteMapping) {
                let kindDescrObj = this.getKindDescrObject(resultingType.kind);
                let target_canContinuous = kindDescrObj.canContinuous; //LL: except label and icon

                disabled = !target_canContinuous;
            }

            let title = disabled ? 'Current Mapping Type cannot be applied to this Target Type' : '';

            return (
                <option key={resultingType.kind} value={resultingType.kind} disabled={disabled} title={title}>
                    {resultingType.name}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.resultingType = input;
                }}
                className="form-control"
                style={style1}
                value={displayVal}
                disabled={readOnly}
                onChange={this.processResultingTypeChange}
            >
                {options}
            </select>
        );
    };

    //LL:  new:  for both discrete and linear(log)
    getScale(value) {
        if (value.name == null) {
            return;
        }

        if (this.isDiscreteMapping(value)) {
            return this.getDiscreteIntervals(value);
        } else {
            return this.getLinearScale(value);
        }
    }

    //LL:  new:   for linear and logarithmic
    process_LinearScale_Change = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.linearScale = val;
        this.handleValueChange(obj);
    };

    //LL:  new:   for linear and logarithmic
    getLinearScale(value) {
        if (value.name == null) {
            return;
        }

        let dataType = value.dataType || dataTypes[dataTypesIndexDefault];

        let resultingType = value.resultingType || this.props.resultingTypes[0].kind;

        let displayVal_linearScale: any = value.linearScale; //  may be null

        return (
            <ContinuousScale
                value={displayVal_linearScale}
                type={dataType}
                kind={resultingType}
                onChange={this.process_LinearScale_Change}
                themeObj={this.props.themeObj}
                glob={this.props.glob}
            />
        );
    }

    process_DiscreteIntervals_Change = (val) => {
        //   val:  { labels:[], values:[] }
        let obj = _.clone(this.props.value || {});
        obj.discreteIntervals = val;
        this.handleValueChange(obj);
    };

    getDiscreteIntervals(value) {
        if (value.name == null) {
            return;
        }

        let dataType = value.dataType || dataTypes[dataTypesIndexDefault];
        let resultingType = value.resultingType || this.props.resultingTypes[0].kind;
        let displayVal_discreteIntervals: any = value.discreteIntervals; //  may be null

        //  sample: kind={ DiscreteIntervalsKind.icon }
        return (
            <DiscreteIntervals_forKind
                value={displayVal_discreteIntervals}
                type={dataType}
                kind={resultingType}
                onChange={this.process_DiscreteIntervals_Change}
                themeObj={this.props.themeObj}
                glob={this.props.glob}
            />
        );
    }

    render() {
        let value = this.props.value || {};
        let style1: any = {};

        if (value.disabled === true) {
            style1.backgroundColor = '#eeeeee';
            style1.cursor = 'default';
        }

        //   { this.getDiscreteIntervals(value) }   getScale

        return (
            <tr style={style1}>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                <td className="cell-name" title={this.getNameTitle(value)}>
                    {this.getName(value)}
                </td>
                <td className="cell-mapping">{this.getMappingType(value)}</td>
                <td className="cell-dataType">{this.getDataType(value)}</td>
                <td className="cell-resultingType">{this.getResultingType(value)}</td>
                <td className="cell-scale">{this.getScale(value)}</td>
            </tr>
        );
    }
}

export default class MappingField extends React.Component<any, any> {
    public static reduceByType(ColorMappingArr, aType) {
        if (ColorMappingArr == null) {
            return null;
        }

        let arr = [];

        _.each(ColorMappingArr, function (cm: any, index) {
            let toAdd = true;

            switch (aType) {
                case 'i':
                case 'r':
                    toAdd = cm.dataType === 'i' || cm.dataType === 'r' || cm.dataType === 'number';
                    break;
                case 'date':
                case 'datetime':
                    toAdd = cm.dataType === 'date' || cm.dataType === 'datetime';
                    break;
                case 'time':
                    toAdd = cm.dataType === 'time';
                    break;
            }

            if (toAdd) {
                arr.push(cm);
            }
        });

        return arr;
    }

    // DiscreteIntervalsKind
    private resultingTypes: IKindListForDiscreteMapping[] = [];

    constructor(props) {
        super(props);

        this.resultingTypes = getKindList_forDiscreteMapping();
    }

    //LL: 18.02.20:  NOTE about Reorder vs Sorting: =============================
    //   Items can either reordered by user's DragDrop or sorted by some internal algorithm (alphabetically here)
    //   Previous solution was Reorder, but it is not convenient and mixing own/parent items is bad
    //   So, now it will be Sorting, see function getSortedValuesByName
    //============================================================================

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        obj.mappingType = mappingTypes[mappingIndexDefault]; // new
        obj.linearScale = null; // new
        obj.discreteIntervals = null; // or {} ?
        obj.dataType = dataTypes[dataTypesIndexDefault];
        obj.resultingType = this.resultingTypes[0].kind;
        obj.disabled = false;
        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    render() {
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;
        let aaa = appTheme.getSortedValuesByName(this.props.value);

        let rows = _.map(aaa.arr, (obj, i) => {
            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'MappingField');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            //LL: 'number', instead of i, r
            if (obj2.dataType === 'i' || obj2.dataType === 'r') {
                if (obj2.dataType === 'i' && obj2.discreteIntervals != null) {
                    obj2.discreteIntervals.precision = 0;
                }

                obj2.dataType = 'number';
            }

            let j = aaa.indices[i]; //LL: 17.02.20

            //   i={ i }  was
            return (
                <MappingFieldRow
                    key={i + '-' + obj2.name}
                    i={j}
                    value={obj2}
                    resultingTypes={this.resultingTypes}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                />
            );
        });

        let showTableHeaders = rows.length > 0;
        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px
        let style2 = {
            paddingBottom: 15
        };

        //LL: by Leo:
        //   Resulting Type -> Target Type,   Source Data Type -> Source Type

        return (
            <div className={'mapping-field'}>
                <div className={'div-container'} style={style2}>
                    <div className="mapping-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-name">{'Name'}</th>
                                    <th className="cell-mapping">{'Mapping Type'}</th>
                                    <th className="cell-dataType">{'Source Type'}</th>
                                    <th className="cell-resultingType">{'Target Type'}</th>
                                    <th className="cell-scale">{'Mapping'}</th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody>
                            {rows}
                            <MappingFieldRow
                                resultingTypes={this.resultingTypes}
                                themeObj={this.props.themeObj}
                                glob={this.props.glob}
                                onChange={this.addRow}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
